import React, { useState } from 'react';
import axios from 'axios';
import AuthFormContainer from './AuthFormContainer';
import AuthInput from './AuthInput';

function AdminLogin({ onLogin }) {
  const [adminToken, setAdminToken] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('/api/auth/admin-login', {
        admin_token: adminToken
      });

      if (response.data.success && response.data.user.admin === 1) {
        const { token, user } = response.data;
        localStorage.setItem('timeLockToken', token);
        localStorage.setItem('timeLockUser', JSON.stringify(user));
        localStorage.setItem('adminToken', adminToken);
        onLogin(user);
      } else {
        setError('❌ Invalid admin token');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Admin login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthFormContainer
      title="👑 Admin Panel"
      subtitle="Token-based authentication"
      error={error}
      loading={loading}
      onSubmit={handleSubmit}
      buttonText="Login"
      footerText={
        <>
          Admin access required.<br/>
          <span className="text-slate-500">Contact your administrator for your token.</span>
        </>
      }
    >
      <AuthInput
        label="Admin Token"
        type="password"
        value={adminToken}
        onChange={(e) => setAdminToken(e.target.value)}
        placeholder="Enter your admin token"
        isMono={true}
      />
    </AuthFormContainer>
  );
}

export default AdminLogin;
